import { render, staticRenderFns } from "./p_recruit028.vue?vue&type=template&id=4d1b40be&scoped=true&"
import script from "./p_recruit028.vue?vue&type=script&lang=js&"
export * from "./p_recruit028.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1b40be",
  null
  
)

export default component.exports